import {
  type DefaultOptionType,
  Form,
  NumericFormatField,
  SelectField,
  SubmitButton,
} from '@/components';
import { UpdateExecutionProgressIncomeAndExpenditureFormSchema } from '@/features/project/projects/_models/execution-progress';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

type FormValues = z.infer<
  typeof UpdateExecutionProgressIncomeAndExpenditureFormSchema
>;

type Props = {
  endOfYear: number;
  accountingTypeOptions: DefaultOptionType[] | undefined;
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
};

export const UpdateExecutionProgressIncomeAndExpenditureSummaryForm: FC<
  Props
> = ({ endOfYear, accountingTypeOptions, initialValues, onSubmit }) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors, isDirty, isSubmitting, isSubmitSuccessful },
    handleSubmit,
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(
      UpdateExecutionProgressIncomeAndExpenditureFormSchema,
    ),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <NumericFormatField
        name="numberOfLocalFundBuilding"
        label={t('number-of-local-fund-building-with-year', {
          fiscalYear: endOfYear,
        })}
        control={control}
        errors={errors}
        addonAfter={t('number-unit')}
        allowNegative={false}
      />
      <SelectField
        name="accountingTypeIds"
        label={t('accounting-type')}
        control={control}
        options={accountingTypeOptions}
        errors={errors}
        mode="multiple"
      />
      <SubmitButton disabled={!isDirty} loading={isSubmitting} />
    </Form>
  );
};
